import { Lead, Skeleton } from '@dnb/eufemia';
import { Form, Value } from '@dnb/eufemia/extensions/forms';
import type { JSX } from 'react';

export default function SectionSkeleton({ title }: { title: string }): JSX.Element {
  return (
    <Form.Card innerSpace="small" outline="var(--color-black-8)" outset={false}>
      <Lead size="basis">{title}</Lead>
      <Skeleton show>
        <Value.SummaryList layout="horizontal">
          <Value.String label="Placeholder" value="Placeholder value" />
          <Value.String label="Placeholder" value="Placeholder value" />
          <Value.String label="Placeholder" value="Placeholder value" />
        </Value.SummaryList>
      </Skeleton>
    </Form.Card>
  );
}
